module.exports = __webpack_public_path__ + "img/00014.cd8216db.webp";